import * as Sentry from "@sentry/react";

/* Error tracking. No-op unless REACT_APP_SENTRY_DSN is set at build time, so
   the app ships clean and Sentry lights up the moment you add the DSN.
   Exposes window.Sentry so the app-wide ErrorBoundary reports through it. */
export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;
  try {
    Sentry.init({
      dsn,
      environment: process.env.REACT_APP_SENTRY_ENV || process.env.REACT_APP_ENVIRONMENT || "production",
      release: process.env.REACT_APP_BUILD_ID || undefined,
      tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES || 0),
      replaysOnErrorSampleRate: 0,
      sendDefaultPii: false,
    });
    window.Sentry = Sentry;
  } catch (_) {
    /* never let telemetry break the app */
  }
}

/* Tag the signed-in user on Sentry events (called from AuthContext). */
export function setSentryUser(user) {
  if (!window.Sentry) return;
  try {
    if (user) window.Sentry.setUser({ id: user.user_id, email: undefined, role: user.role });
    else window.Sentry.setUser(null);
  } catch (_) {}
}
